import React from "react";
//import "./UserDefinedMetricParameters.css"
import { ComparitorData } from "../types";
//import { ComparitorData } from '../types';

interface ParametersSelectedProps {
    ComparitorDatas: ComparitorData;
    setComparitorDatas: React.Dispatch<React.SetStateAction<ComparitorData>>;
}

const ParametersSelected: React.FC<ParametersSelectedProps> = ({ ComparitorDatas, setComparitorDatas }) => {

    const handleDelete = (variable_name: string) => {
        setComparitorDatas((prevData) => {
          // Create a new copy of 'variables' without the deleted key
          const { [variable_name]: _, ...updatedVariables } = prevData.variables;
      
          // Return a new state object with updated 'variables'
          return {
            ...prevData,
            variables: updatedVariables,
          };
        });
      };

      return (
        <div style={{ 
          border: '0', 
          borderRadius: '4px', 
          padding: '15px', 
          backgroundColor: 'white',
          marginBottom: '15px'
        }}>

              {Object.entries(ComparitorDatas.variables).map(([key, variable], index) => (
                <div key={`defined_params-${index}`} 
                    style={{
                        border: '1px solid #4a6fa5',
                        borderLeft: '1px solid #4a6fa5',
                        borderRadius: '8px',
                        padding: '5px',
                        marginBottom: '5px',
                        //backgroundColor: current_selected_index === index ? '#f7f9ff' : 'white',
                        backgroundColor: 'white',
                        position: 'relative',
                        minHeight: '100px',
                    }}
                >
                    <div style={{ 
                        fontSize: '15px', 
                        fontWeight: 500, 
                        marginBottom: '5px',
                        color: '#3F51B5'
                    }}>
                        <b>{key}</b>: { variable.dataset_title}
                    </div>
                    <div style={{ 
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: '10px',
                        marginBottom: '5px',
                        width: '100%'
                        
                    }}>
                        { <div style={{
                            padding: '6px 12px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '16px',
                            border: '1px solid #e0e0e0',
                            color: '#3F51B5',
                            fontWeight: 500,
                            fontSize: '14px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '100%',
                            minHeight: '32px', // Add minimum height
                            minWidth: '40px',  // Add minimum width
                        }}>
                            { variable.is_user_defined ? "User Defined" : variable.attribute_title}
                        </div> }

                        {
                            Object.keys(variable.parameter).map((key, paramIndex) => {
                            const param = variable.parameter[key as keyof typeof variable.parameter];

                            const { titles, codes, current_code } = param as {
                                type: "Slider" | "Dropdown" | "Radio";
                                titles: string[];
                                codes: string[];
                                current_code: string;
                            };

                            const index_code = codes.indexOf(current_code);
                            const title = titles[index_code];
                            
                            return (
                                <div 
                                    key={`param-${paramIndex}`}
                                    style={{
                                        padding: '6px 12px',
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: '16px',
                                        border: '1px solid #e0e0e0',
                                        color: '#3F51B5',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '100%',
                                        minHeight: '32px', // Add minimum height
                                        minWidth: '40px',  // Add minimum width
                                    }}
                                >
                                    {title}
                                </div>
                            );
                            })
                        }
                                            
                        { variable.year != undefined  && (!isNaN(variable.year)) && <div style={{
                            padding: '6px 12px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '16px',
                            border: '1px solid #e0e0e0',
                            color: '#3F51B5',
                            fontWeight: 500,
                            fontSize: '14px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '100%',

                            minHeight: '32px', // Add minimum height
                            minWidth: '40px',  // Add minimum width
                        }}>
                            {variable.year}
                        </div> }
                        
                        <div style={{
                            padding: '6px 12px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '16px',
                            border: '1px solid #e0e0e0',
                            color: '#3F51B5',
                            fontWeight: 500,
                            fontSize: '14px',
                            whiteSpace: 'nowrap',  // Keep on one line
                            overflow: 'hidden',    // Hide overflow
                            textOverflow: 'ellipsis', // Show ellipsis
                            maxWidth: '100%',      // Take full available width
                            display: 'inline-block', // Necessary for text-overflow to work

                            minHeight: '32px', // Add minimum height
                            minWidth: '40px',  // Add minimum width
                        }}>
                            {variable.type}
                        </div>
                    </div>
                    
                    {/* Action buttons */}
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'flex-end',
                        gap: '12px'
                    }}>
                        
                        <button
                            onClick={() => handleDelete(key)}
                            style={{ 
                                backgroundColor: 'transparent',
                                border: 'none',
                                color: '#2196F3',
                                cursor: 'pointer',
                                padding: '4px 8px',
                                fontSize: '14px'
                            }}
                        >
                            Delete
                        </button>
                    </div>
                </div>
            ))}

        </div>
      );
};

export default ParametersSelected;
